module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "assets/unzip_imgs.worker.cb8eecb47b7e72c92c19.js");
}
